import { IconRows } from '@/components/icons/IconRows';
import { IconRowsFill } from '@/components/icons/IconRowsFill';
import { IconSquaresFour } from '@/components/icons/IconSquaresFour';
import { IconSquaresFourFill } from '@/components/icons/IconSquaresFourFill';
import { cn } from '@/lib/utils/tw-merge';
import type { VehicleView } from './vehicleListing.constants';

// The active view shows the filled glyph of the same set: same box, no shift.
const VIEWS = [
    { value: 'grid', label: 'Raster', name: 'Rasteransicht', Icon: IconSquaresFour, ActiveIcon: IconSquaresFourFill },
    { value: 'list', label: 'Liste', name: 'Listenansicht', Icon: IconRows, ActiveIcon: IconRowsFill },
] as const;

type VehicleViewSwitchProps = {
    view: VehicleView;
    onChange: (view: VehicleView) => void;
    /** `segmented`: icons in the toolbar; `chips`: icon and text in the filter drawer. */
    variant?: 'segmented' | 'chips';
    className?: string;
};

export function VehicleViewSwitch({ view, onChange, variant = 'segmented', className }: VehicleViewSwitchProps) {
    const isChips = variant === 'chips';

    return (
        <div
            role="group"
            aria-label="Ansicht"
            className={cn(isChips ? 'vehicle-filter__chips' : 'vehicle-view-switch', className)}
        >
            {VIEWS.map(({ value, label, name, Icon, ActiveIcon }) => {
                const active = view === value;
                const Glyph = active ? ActiveIcon : Icon;

                return (
                    <button
                        key={value}
                        type="button"
                        aria-pressed={active}
                        aria-label={isChips ? undefined : name}
                        className={
                            isChips
                                ? 'vehicle-filter-chip vehicle-filter-chip--icon label-xs'
                                : 'vehicle-view-switch__button'
                        }
                        onClick={() => onChange(value)}
                    >
                        <Glyph width={isChips ? 18 : 17} height={isChips ? 18 : 17} aria-hidden="true" />
                        {isChips ? label : null}
                    </button>
                );
            })}
        </div>
    );
}
